import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Spinner } from 'transfix-ui/components/Spinner'
import { IShipment, IStopsSummary } from 'types'
import { IReloadsState } from 'types/reloads'
import { getNearbyLoads, getReloads } from 'utils/actions/reloads'
import { IStore } from 'apps/booking/utils/reducers'
import { useMPAnalytics } from 'apps/marketplace/hooks'
import { stopsSummary } from 'utils/shipmentHelpers'
import { ReloadsFilterLink } from './ReloadsFilterLink'

interface ISelector extends IReloadsState {
  shipment?: IShipment
}

export const Reloads = () => {
  const { trackEvent } = useMPAnalytics()
  const dispatch = useDispatch()
  const { loads, reloads, shipment } = useSelector<IStore, ISelector>(
    ({ reloads: reloadsStore, sidebar: { data } }) => ({
      shipment: data?.shipment,
      loads: reloadsStore.loads,
      reloads: reloadsStore.reloads,
    })
  )

  const showLoads = !loads.fetching && loads.ids.length > 0
  const showReloads = !reloads.fetching && reloads.ids.length > 0

  useEffect(() => {
    if (shipment) {
      dispatch(getNearbyLoads(shipment.id))
      dispatch(getReloads(shipment.id))
    }
  }, [shipment?.id])

  useEffect(() => {
    if (showLoads && loads.shipmentId === shipment?.id) {
      trackEvent('Booking', 'VIEWED_NEARBY_RELOADS')
    }
  }, [loads.shipmentId, showLoads])

  useEffect(() => {
    if (showReloads && reloads.shipmentId === shipment?.id) {
      trackEvent('Booking', 'VIEWED_RELOADS')
    }
  }, [reloads.shipmentId, showReloads])

  const { delivery, pickup } = stopsSummary(shipment) as IStopsSummary
  return (
    <>
      {showLoads && <ReloadsFilterLink type='load' category={loads} stop={pickup} />}
      {showReloads && <ReloadsFilterLink type='reload' category={reloads} stop={delivery} />}
      {(loads.fetching || reloads.fetching) && <Spinner position='relative' />}
    </>
  )
}
